import { _fetchExpStrikeOptionalValue } from "../../controllers/calculator/optionValueCalulation";
import { CALCULATOR } from "../actionTypes";
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - Start

export const getExpStrikeForOptionalValue = (objPayload) => async (dispatch, getState) => {
    const objResp = await _fetchExpStrikeOptionalValue(objPayload);
    dispatch(getExpiryDatesSuccess(objResp.data.arrExpiryDates))
    dispatch(getStrikePriceSuccess(objResp.data.arrStrikePrice))
}

export const getExpiryDatesSuccess = (payload) => {
    return {type: CALCULATOR.GET_EXPIRY_DATES, payload}
}
export const getStrikePriceSuccess = (payload) => {
    return {type: CALCULATOR.GET_STRIKE_PRICE, payload}
}
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - End
